const oidc = {
    logout_success: 'Pomyślnie zostałeś wylogowany.',
};
export default oidc;
